export default "__VITE_ASSET__Dq0R9SHH__"